<div class="container-shadow">
  <div id="drug-distribution-analysis" *ngIf="isTabViewed">
    <div id="drug-distribution-analysis-controls">
      <app-drug-distribution-analysis-grid-controls
        [defaultPeriodObj]="defaultPeriodObj"
        [selectedCurrency]="selectedCurrency"
        [periodRange]="periodRange"
        [dataView]="dataView"
        (dataSettingsChanged)="dataSettingsChanged($event)"
        (onReset)="onFilterReset()"
      >
      </app-drug-distribution-analysis-grid-controls>
    </div>
    <div class="header">
      <span> Analyst Estimates </span>
    </div>
    <div *ngIf="isLoading">
      <nz-skeleton
        [nzTitle]="true"
        [nzActive]="true"
        [nzParagraph]="false"
      ></nz-skeleton>
    </div>
    <div *ngIf="!isLoading">
      <div id="drug-distribution-analysis-chart-container">
        <app-drug-distribution-analysis-chart
          [dataSettings]="dataSettings"
          [dataCall]="dataCall"
          [sourceCall]="sourceCall"
        ></app-drug-distribution-analysis-chart>
      </div>
      <div id="drug-distribution-analysis">
        <div id="drug-distribution-analysis-grid-and-controls-container">
          <div>
            <div
              id="drug-distribution-analysis-grid-section-container-consensus"
            >
              <div class="drug-distribution-analysis-grid-title">
                <span class="table-heading"
                  >Consensus
                  <i *ngIf="dataSettings.revision" class="date-subscript"
                    >as of {{ dataSettings.revisionDate }}</i
                  >
                </span>
              </div>
              <app-drug-distribution-analysis-grid
                [dataSettings]="dataSettings"
                [dataCall]="dataCall"
                serviceFunction="getDistributionPageData"
                tableName="Consensus"
                [periodList]="periodRange"
                [reaffirmCall]="reaffirmCall"
                [drugResearchParameters]="drugResearchParameters"
                (onResearchIconClick)="onResearchIconClick($event)"
                (showResearchParameterOnGrid)="
                  showResearchParameterOnGrid($event)
                "
                [drug_dapparameterid]="drug_dapparameterid"
              >
              </app-drug-distribution-analysis-grid>
            </div>
            <div
              *ngIf="brokerGridCount !== 0"
              id="drug-distribution-analysis-grid-section-container-broker"
            >
              <div class="drug-distribution-analysis-grid-title">
                <span class="table-heading">
                  Brokers
                  <i *ngIf="dataSettings.revision" class="date-subscript"
                    >as of {{ dataSettings.revisionDate }}
                    <nz-divider
                      nzType="vertical"
                      style="
                        margin: 0px 4px;
                        height: 100%;
                        color: #d3d7dd !important;
                      "
                    ></nz-divider>
                  </i>
                  <span *ngIf="isExcluded" class="excluded-container">
                    <nz-tag [nzColor]="'#E9EBEE'" class="excluded-tag"
                      >Ex</nz-tag
                    >
                    <span class="excluded-title">Excluded from consensus</span>
                  </span>
                </span>
                <div id="brokersData" *ngIf="dataSettings.view_by[0] !== 'yoy'">
                  <div class="toggle">
                    <p class="toggle-text">Highlight high/low</p>
                    <nz-switch
                      nzSize="small"
                      [ngModel]="brokersSwitchValue"
                      (ngModelChange)="onBrokerSwitchChange($event)"
                    ></nz-switch>
                    <!-- [nzCheckedChildren]="checkedTemplate"
                    <ng-template #checkedTemplate>
                      <i nz-icon nzType="check"></i>
                    </ng-template> -->
                  </div>
                  <div class="info-class">
                    <i
                      nz-popover
                      nzPopoverPlacement="right"
                      [nzPopoverTitle]="Popovertitle"
                      nzPopoverContent="Only highlighting content when you have access to it"
                      nzPopoverTrigger="hover"
                      class="info-icon"
                      [nzPopoverOverlayStyle]="{ width: '261px' }"
                    >
                      <va-icon size="small" name="info-circle"></va-icon>
                    </i>
                    <ng-template #Popovertitle>
                      <b>Entitlments</b>
                    </ng-template>
                  </div>
                </div>
              </div>
              <app-drug-distribution-analysis-grid
                [dataSettings]="dataSettings"
                [dataCall]="dataCall"
                serviceFunction="getDistributionPageData"
                tableName="Broker"
                [brokerHighLowEnable]="
                  dataSettings.view_by[0] !== 'yoy' ? brokersSwitchValue : false
                "
                [reaffirmCall]="reaffirmCall"
                (onDataSourceChanged)="onDataSourceChanged($event)"
                [drugResearchParameters]="drugResearchParameters"
                (onResearchIconClick)="onResearchIconClickByBroker($event)"
                (showResearchParameterOnGrid)="
                  showResearchParameterOnGridByBroker($event)
                "
                [drug_dapparameterid]="drug_dapparameterid"
              >
              </app-drug-distribution-analysis-grid>
            </div>
            <div
              id="drug-distribution-analysis-grid-section-container-descriptive"
            >
              <div class="drug-distribution-analysis-grid-title">
                <span class="table-heading"
                  >Descriptive statistics
                  <i *ngIf="dataSettings.revision" class="date-subscript"
                    >as of {{ dataSettings.revisionDate }}</i
                  >
                </span>
              </div>
              <app-drug-distribution-analysis-grid
                [dataSettings]="dataSettings"
                serviceFunction="getDistributionPageData"
                tableName="Descriptive statistics"
                [dataCall]="dataCall"
                [reaffirmCall]="reaffirmCall"
              >
              </app-drug-distribution-analysis-grid>
            </div>
            <div id="drug-distribution-analysis-grid-section-container">
              <div class="drug-distribution-analysis-grid-title-quartile">
                <span class="table-heading"
                  >Quartiles
                  <i *ngIf="dataSettings.revision" class="date-subscript"
                    >as of {{ dataSettings.revisionDate }}</i
                  >
                </span>
              </div>
              <app-drug-distribution-analysis-grid
                [dataSettings]="dataSettings"
                serviceFunction="getDistributionPageData"
                [dataCall]="dataCall"
                tableName="Quartiles"
                [reaffirmCall]="reaffirmCall"
              >
              </app-drug-distribution-analysis-grid>
            </div>
            <div id="drug-distribution-analysis-grid-section-container">
              <div class="drug-distribution-analysis-grid-title-quartile">
                <span class="table-heading"
                  >Trimmed Means
                  <i *ngIf="dataSettings.revision" class="date-subscript"
                    >as of {{ dataSettings.revisionDate }}</i
                  >
                </span>
              </div>
              <app-drug-distribution-analysis-grid
                [dataSettings]="dataSettings"
                [dataCall]="dataCall"
                serviceFunction="getDistributionPageData"
                tableName="Trimmed Means"
                [reaffirmCall]="reaffirmCall"
              >
              </app-drug-distribution-analysis-grid>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-pharma-research-insight-popup
      [(ticker)]="ticker"
      [(dapParamObj)]="currentDapObj"
      [(showPopup)]="showResearchPopup"
      (closePopup)="hideResearchInsightPopup()"
    ></app-pharma-research-insight-popup>
    <div
      class="popupBlockUI"
      style="
        display: none;
        border: none;
        margin: 0px;
        padding: 0px;
        width: 100%;
        height: 100%;
        top: 0px;
        left: 0px;
        opacity: 0.6;
        cursor: default;
        position: fixed;
        z-index: 100;
        background-color: rgb(0, 0, 0);
      "
    ></div>
  </div>
</div>
